export const clientInfoContent = [
  {
    title: 'Лоялдылық бағдарламаға қатысып БОНУСТАР алыңыз! 🎁✨',
    actionsTitle: '4 қарапайым қадам:',
    actions: [
      '📱 QR-кодты сканерлеңіз',
      '🌐 QR-дегі сілтеме арқылы сайтты ашыңыз',
      '📞 Телефон нөміріңізді енгізіңіз',
      '🔐 Осы терезеде SMS-тен келген кодты енгізіңіз',
    ],
  },
  {
    title: 'Участвуйте в программе лояльности и получайте БОНУСЫ ! 🎁✨',
    actionsTitle: ' 4 простых действия:',
    actions: [
      '📱 Отсканируйте QR-код',
      '🌐 Откройте сайт по ссылке в QR',
      '📞 Введите свой номер',
      '🔐 В этом же окне введите код из SMS',
    ],
  },
];
